/*******************************************************************************
Activate Ripple Effect on Buttons
Creates the ripple effect when a button is clicked.
*******************************************************************************/

export default function activateRippleEffect(e) {

    // Get rid of any ripple or hover effects on all buttons to start
    $('.ripple-effect').removeClass('ripple-effect');
    //$('button').removeClass('hovering');

    const $button = $(this);

    // If the button has the 'no-ripple' class, then exit out
    if ($button.hasClass('no-ripple')) { return; }

    const $div = $('<div/>', { class: 'ripple-effect' });

    const btnOffset = $button.offset();
    const xPos = e.pageX - btnOffset.left;
    const yPos = e.pageY - btnOffset.top;

    // Position the ripple effect and add it to the button
    $div.css({
        top : yPos - ($div.height() / 2),
        left: xPos - ($div.width() / 2),
    }).appendTo($button);

    // Remove the ripple effect after 1 second (needs to match CSS animation!)
    setTimeout(() => { $div.remove(); }, 1000);
}
